import { render, staticRenderFns } from "./PracticeEdit.vue?vue&type=template&id=10d33e1e"
import script from "./PracticeEdit.vue?vue&type=script&lang=js"
export * from "./PracticeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports